import { css } from 'lit';

import { reducedMotion } from '../media.js';

export const planeBadgeStyles = css`
  :host {
    --badge-fg: var(--tone-muted);
    --badge-bg: var(--tone-muted-soft);
    display: inline-flex;
    align-items: center;
    gap: 0.5em;
    padding: var(--badge-padding);
    border: var(--border-width) solid color-mix(in srgb, var(--badge-fg) var(--tone-border-mix), transparent);
    border-radius: var(--radius);
    background: var(--badge-bg);
    color: var(--badge-fg);
    font-family: var(--font-mono);
    font-size: var(--font-size-2xs);
    font-weight: var(--font-weight-semibold);
    letter-spacing: var(--tracking-wider);
    text-transform: uppercase;
    line-height: var(--line-height-relaxed);
    white-space: nowrap;
    vertical-align: middle;
  }

  /* The colour key of a line: a square, filled with the tone, always beside its name. */
  :host::before {
    content: '';
    width: var(--bullet-size);
    height: var(--bullet-size);
    background: currentColor;
  }

  :host([pulse])::before {
    animation: pulse var(--duration-pulse) var(--ease-in-out) infinite;
  }

  @keyframes pulse {
    50% {
      opacity: 0.25;
      transform: scale(0.6);
    }
  }

  @media ${reducedMotion} {
    :host([pulse])::before {
      animation: none;
    }
  }

  :host([tone='ok']) {
    --badge-fg: var(--tone-ok);
    --badge-bg: var(--tone-ok-soft);
  }

  :host([tone='progress']) {
    --badge-fg: var(--tone-progress);
    --badge-bg: var(--tone-progress-soft);
  }

  :host([tone='warning']) {
    --badge-fg: var(--tone-warning);
    --badge-bg: var(--tone-warning-soft);
  }

  :host([tone='danger']) {
    --badge-fg: var(--tone-danger);
    --badge-bg: var(--tone-danger-soft);
  }
`;
